import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy',
  standalone: true,
})
export class FilterByPipe implements PipeTransform {
  /**
   * @description Used to filter out fields that do not have the filterString present within it.
   **/
  public transform<T>(value: T[], fieldToFilterBy: keyof T, filterString = '') {
    const sortedCopy = [...value];
    return this.filter(sortedCopy, fieldToFilterBy, filterString);
  }

  private filter<T>(list: T[], fieldToFilterBy: keyof T, filterString: string) {
    filterString = filterString.toLowerCase();
    list = list.filter(
      (elem) =>
        typeof elem[fieldToFilterBy] === 'string' &&
        elem[fieldToFilterBy].toLowerCase().includes(filterString),
    );
    return list;
  }
}
